import * as React from "react";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import { FieldArray, useFormikContext } from "formik";
import styled, { css } from "styled-components";
import { SortableList } from "components/common";
import SortConfiguration from "./SortConfiguration";
import SortElement from "./SortElement";
import ElementConfigurationContainer from "../ElementConfigurationContainer";
const SortConfigurationContainer = styled(ElementConfigurationContainer)(
  ({ theme }) => css`
    @media (min-width: ${theme.breakpoints.max.md}) {
      padding-top: 27px;
    }
  `
);
const SortsConfiguration = () => {
  const { t } = useTranslation("aggregation");
  const {
    values: { sort },
    setFieldValue,
    setValues,
    values
  } = useFormikContext();
  const removeSort = useCallback(
    (index) => () => {
      setValues(SortElement.onRemove(index, values));
    },
    [setValues, values]
  );
  const customListItemRender = useCallback(
    (props) => {
      const { item, index, dragHandle, className, ref } = props;
      return /* @__PURE__ */ React.createElement(
        SortConfigurationContainer,
        {
          key: `sort-${item.id}`,
          dragHandle,
          className,
          onRemove: removeSort(index),
          elementTitle: t("wizard_common.sort"),
          ref
        },
        /* @__PURE__ */ React.createElement(SortConfiguration, { index })
      );
    },
    [removeSort, t]
  );
  return /* @__PURE__ */ React.createElement(
    FieldArray,
    {
      name: "sort",
      validateOnChange: false,
      render: () => /* @__PURE__ */ React.createElement(
        SortableList,
        {
          items: sort,
          onMoveItem: (newSort) => setFieldValue("sort", newSort),
          customListItemRender
        }
      )
    }
  );
};
export default SortsConfiguration;
